import React, { useEffect, useRef, useState } from "react";
import { GROUPS, OPEN_CHATS } from "../../store";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BASE_URL } from "../../helper/constants";
import { Scrollbars } from "react-custom-scrollbars";
import "../../styles/pages.css";
import Iframe from "react-iframe";
import FileViewer from "react-file-viewer";
import { Document, Page, pdfjs } from "react-pdf";
import { AiOutlineFullscreen } from "react-icons/ai";
import { HiDownload } from "react-icons/hi";
import axios from "axios";
import "./DocViewer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    overflowX: "hidden",
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function DocViewer(props) {
  const [fileUrl, setFileUrl] = useState("");
  const [onlyfileUrl, setOnlyFileUrl] = useState("");

  const [fileType, setFileType] = useState("");
  const [pageWidth, setPageWidth] = useState(null);
  const docFileRef = useRef(null);

  useEffect(() => {
    const el = docFileRef.current;
    if (!el) return undefined;
    const measure = () => setPageWidth(Math.max(1, Math.floor(el.clientWidth)));
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [fileType, onlyfileUrl]);

  useEffect(() => {
    const ft = (props.chat.attachedFileName?.split(".").pop() || "").trim().toLowerCase();
    setFileType(ft);
    const raw = Array.isArray(props.chat?.fileUrl) ? props.chat.fileUrl[0] : props.chat?.fileUrl;
    const absolute =
      raw && (String(raw).startsWith("http") || String(raw).startsWith("blob:"))
        ? raw
        : BASE_URL + (raw || "");
    let file = absolute;
    switch (ft) {
      case "doc":
        setFileUrl(
          "https://docs.google.com/viewer?url=" + file + "&embedded=true"
        );
        setOnlyFileUrl(file);
        break;
      case "docx":
        setFileUrl(
          "https://docs.google.com/viewer?url=" + file + "&embedded=true"
        );
        setOnlyFileUrl(file);
        break;
      case "xls":
        setFileUrl(
          "https://docs.google.com/viewer?url=" + file + "&embedded=true"
        );
        setOnlyFileUrl(file);
        break;
      case "xlsx":
        setFileUrl(
          "https://docs.google.com/viewer?url=" + file + "&embedded=true"
        );
        setOnlyFileUrl(file);
        break;
      case "pdf":
        setFileUrl(
          "https://docs.google.com/viewer?url=" + file + "&embedded=true"
        );
        setOnlyFileUrl(file);
        break;
      case "txt":
        let tempFile = file?.replace(".txt", ".pdf");
        setFileUrl(
          "https://docs.google.com/viewer?url=" + tempFile + "&embedded=true"
        );
        setOnlyFileUrl(tempFile);
        break;
      default:
        setFileUrl(
          "https://docs.google.com/viewer?url=" + file + "&embedded=true"
        );
        setOnlyFileUrl(file);
        break;
    }
  }, []);
  const onError = () => {
    console.log("error");
  };
  const isInternal = !!props.isInternal;
  const actionBtnClass = `kj-btn kj-btn--icon kj-btn--lg kj-btn--primary${isInternal ? " kj-btn--internal" : ""} doc-viewer__action`;
  console.log("fileUrl=>", fileUrl);
  return (
    <React.Fragment>
      <div
        className={`doc-viewer-panel w-300 my_project pt-0 immoanimation-enter-done px-2 doc-viewer__panel${isInternal ? " doc-viewer__panel--internal" : ""}`}
      >
        <div className={isInternal ? "main_heading main_heading-internal" : "main_heading"}>
          <a className="pointer ml-2 media-back-btn" onClick={props.handleClose}>
            <span
              className={`material-symbols-outlined doc-viewer__back-icon${isInternal ? " doc-viewer__back-icon--internal" : ""}`}
            >
              keyboard_arrow_left
            </span>
          </a>
          {fileType === "doc" || fileType === "docx"
            ? "Doc"
            : fileType === "xlsx"
            ? "XSL"
            : fileType === "txt"
            ? "TXT"
            : fileType === "pdf"
            ? "PDF"
            : fileType}{" "}
          File
          <div />
        </div>
        <div className="wscroll right_wscroll h-100">
          <CustomScrollbars
            autoHide
            autoHideTimeout={200}
            autoHideDuration={200}
            className="bottom-bar"
          >
            <div className="doc-file" ref={docFileRef}>
              {fileType === "txt" || fileType === "doc" ? (
                <Iframe
                  src={fileUrl}
                  download={props.chat.attachedFileName}
                  title="file"
                  width="100%"
                  height="600"
                />
              ) : fileType === "pdf" ? (
                <Document
                  file={{
                    url: onlyfileUrl,
                  }}
                  // width="100%"
                  // height="600"
                  // onLoadSuccess={(onDocumentLoadSuccess)}
                >
                  <Page pageNumber={1} width={pageWidth || undefined} />
                </Document>
              ) : (
                <FileViewer
                  width="100"
                  height="600"
                  fileType={fileType}
                  filePath={onlyfileUrl}
                  onError={onError}
                />
              )}
              <button
                className={`${actionBtnClass} doc-viewer__action--fullscreen`}
                onClick={() => {
                  window.open(fileUrl, "_blank");
                }}
              >
                <AiOutlineFullscreen
                  color="#fff"
                  width={30}
                  height={30}
                  className="doc-viewer__action-icon"
                />
              </button>
              <button
                className={`${actionBtnClass} doc-viewer__action--download`}
                onClick={() => {
                  axios({
                    url: onlyfileUrl,
                    method: "GET",
                    responseType: "blob",
                  }).then((response) => {
                    const url = window.URL.createObjectURL(
                      new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `${props?.chat?.attachedFileName?.split(".").shift().trim()}.${fileType}`);
                    document.body.appendChild(link);
                    link.click();
                  });
                }}
              >
                <HiDownload
                  color="#fff"
                  width={30}
                  height={30}
                  className="doc-viewer__action-icon"
                />
              </button>
            </div>
          </CustomScrollbars>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const { openChats, groups } = state;
  return {
    groups: groups,
    openChats: openChats,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    updateOpenChatsList: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DocViewer));
